import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setIsLoading, setWorkInLocationList, } from "../slices/reportSlice";
import * as services from "../services/reportApi";
import { generateRandomString } from "utils/helper";
import * as slices from "../slices/reportSlice"
import * as employeeServices from "features/employee/services/employeeApi";
import { setReportTableWorkingTime } from "../slices/reportSlice";
import { getEmployeeStatusTypeOptions, getEmploymentTypeOptions } from "features/masterData/services/optionsApi";
import useOptions from "features/masterData/hooks/useOptions";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import dayjs from "dayjs";

function useWorkingTimeGroup() {
    const [showReport, setShowReport] = useState(false);
    const { t, i18n } = useTranslation();
    const { currentEmployee } = useSelector((state) => state.company)
    const currentEmployeeId = useSelector((state) => state.company.currentEmployee);
    const dispatch = useDispatch();
    const [lang, setLang] = useState("en");
    const { employeeStatusTypeOptions, getEmployeeStstuaTypeOptions } = useOptions();
    const reportTableWoringTime = useSelector((state) => state.report.reportTableWoringTime || []);
    const reportTableWoringTime2 = useSelector((state) => state.report.reportTableWoringTime2 || []);
    const [positionOptions, setPositionOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [departmentListOption, setDepartmentListOption] = useState([]);
    const [workInLocationList, setWorkInLocationList] = useState([]);
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const [pagination, setPagination] = useState({ page: 0, currentPage: 0, size: 10 });
    const [pagination2, setPagination2] = useState({ page: 0, currentPage: 0, size: 10 });
    const [search, setSearch] = useState({});
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingTA, setIsDownloadingTA] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    function toParams(params = {}) {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            pagination: {
                page: pagination?.page,
                size: pagination?.pageSize,
            },
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;
    }

    const getReportTableWorkingTime = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                console.log("parrrrrm", params);

                const response = await services.getReportTableWorkingTime({
                    ...params,
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    ...params.pagination,
                });
                console.log("Response data jaaa", response?.data?.page?.content);

                const employeeNos = response?.data?.page?.content?.map((item) => item?.employeeInfo?.employeeNo);
                console.log("Employee Nos:", employeeNos);

                dispatch(setReportTableWorkingTime(response?.data?.page?.content));
                setPagination({
                    ...pagination,
                    // ...params?.request,
                    current: response?.data?.page?.pageable?.pageNumber + 1,
                    pageNo: response?.data?.page?.pageable?.pageNumber + 1,
                    size: response?.data?.page?.pageable?.pageSize,
                    total: response.data?.page?.totalElements,
                });
                return employeeNos;
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, reportTableWoringTime, currentEmployee, pagination]
    );
    const getReportTableWorkingTimeCustomer = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                console.log("parrrrrm", params);

                const response = await services.getReportTableWorkingTimeCustomer({
                    ...params,
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    ...params.pagination,
                });
                console.log("Response data jaaa", response?.data?.page?.content);

                const employeeNos = response?.data?.page?.content?.map((item) => item?.employeeInfo?.employeeNo);
                console.log("Employee Nos:", employeeNos);

                dispatch(slices.setReportTableWorkingTime2(response?.data?.page?.content));
                setPagination2({
                    ...pagination2,
                    // ...params?.request,
                    current: response?.data?.page?.pageable?.pageNumber + 1,
                    pageNo: response?.data?.page?.pageable?.pageNumber + 1,
                    size: response?.data?.page?.pageable?.pageSize,
                    total: response.data?.page?.totalElements,
                });
                return employeeNos;
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, reportTableWoringTime, currentEmployee, pagination2]
    );


    const getPosition = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployeeId
                };
                const response = await services.getPositionDropdownList(values);
                setPositionOptions(response?.data?.content || []);
            } catch (error) {
                // alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, currentEmployeeId, dispatch]);

    const getWorkInLocation = useCallback(async () => {
        try {
            // dispatch(setIsLoading(true))
            const response = await services.getWorkInLocation({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee
            })
            dispatch(setWorkInLocationList(response?.data))
            // Alert({ message: 'success', type: 'success' })
        } catch (error) {
            // alert({ type: 'error', resultObject: error })
        } finally {
            // dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, dispatch])

    const modifiedEmployeeOptions = useMemo(() => {
        return employeeOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.fullNameEn : opt.fullName,
            value: opt.id,
        }));
    }, [lang, employeeOptions]);

    const getEmployeeOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await employeeServices.getDropDown(values);
                setEmployeeOptions(response.data);
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);





    const modifiedWorkInLocationList = useMemo(() => {
        const modifiedOptions = workInLocationList?.map((workInLocation) => {
            return {
                label: workInLocation?.name,
                value: workInLocation?.id
            }
        })
        return modifiedOptions?.sort((a, b) =>
            a?.label?.localeCompare(b?.label, i18n?.language === "en" ? "en" : "th", { sensitivity: "base" }));
    }, [i18n.language, workInLocationList])

    const modifiedPositionOptions = useMemo(() => {
        const modifiedOptions = positionOptions.map((opt) => ({
            ...opt,
            id: opt?.positionId,
            value: opt?.positionId,
            nameEn: opt?.positionNameEn,
            name: opt?.positionName,
            label: i18n.language === "en" ? opt?.positionNameEn : opt?.positionName,
        }));
        return modifiedOptions?.sort((a, b) =>
            a?.label?.localeCompare(b?.label, i18n?.language === "en" ? "en" : "th", { sensitivity: "base" }));
    }, [i18n.language, positionOptions]);

    const modifiedDepartmentOption = useMemo(() => {
        const modifiedOptions = departmentListOption?.map((opt) => ({
            ...opt,
            value: opt?.id,
            label: i18n.language === "en" ? opt?.nameEn : opt?.name,
        }));

        return modifiedOptions?.sort((a, b) =>
            a?.label?.localeCompare(b?.label, i18n?.language === "en" ? "en" : "th", { sensitivity: "base" }));;
    }, [i18n.language, departmentListOption]);



    const onChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            console.log('table', tablePagination);

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination.current - 1,
                    pageSize: tablePagination.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });
            setPagination({ ...pagination, ...modifiedParams?.pagination })
            getReportTableWorkingTime({ ...modifiedParams, request: pagination.request, ...search });
        },
        [getReportTableWorkingTime, pagination]
    );

    const onChange2 = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            console.log('table', tablePagination);

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination.current - 1,
                    pageSize: tablePagination.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });
            setPagination2({ ...pagination2, ...modifiedParams?.pagination })
            getReportTableWorkingTimeCustomer({ ...modifiedParams, request: pagination2.request, ...search });
        },
        [getReportTableWorkingTimeCustomer, pagination2]
    );


    const getDepartment = useCallback(async () => {
        if (!currentCompany) return null;
        try {
            dispatch(setIsLoading(true));
            const response = await services.getDropdownDepartmentByRoleHr({
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentEmployeeId
            });
            dispatch(setDepartmentListOption(response?.data?.content || []));
        } catch (error) {
            // alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployeeId, dispatch]);


    const exportWorkingTimeGroupReport = useCallback(
        async (record) => {
            try {
                // console.log("onDownload");
                dispatch(setIsLoading(true));
                const res = await services.ExportWorkingTimeGroupReportPagingeByEmp({
                    companyId: currentCompany,
                    ...search,
                    ...pagination,
                    isReport: "Y",
                    employeeId: record?.employeeInfo?.id
                });
                // console.log("res ", res);

                if (res && res.data) {
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "WorkingTimeReport.xlsx");

                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    window.URL.revokeObjectURL(url);
                } else {
                    console.error("No data received for the download.");
                }
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, pagination, search, dispatch]
    );

    const exportWorkingTimeGroupReportAll = useCallback(
        async (params = {}) => {
            try {
                setIsDownloading(true);
                dispatch(setIsLoading(true));
                // console.log("reparamss", params);
                // let idTxn = "68383900a8fe1b0177267bcd"

                // async function callbackFn(idTxn) {
                //     let resData = await services.ExportcheckTxnReportProcessing({
                //         reportId: idTxn
                //     })
                //     console.log("resData", resData);
                //     return resData;
                // }
                // let resu = await callbackFn(idTxn)
                // console.log("resu", resu);

                // const url = window.URL.createObjectURL(resu?.data);
                // const link = document.createElement('a');
                // link.href = url;
                // link.setAttribute('download', "WorkingTimeReport.xlsx");
                // document.body.appendChild(link);
                // link.click();
                // link.remove();
                let creRes = await services.ExportCreateTxnReportProcessing({
                    reportName: "TIME_STAMP_REPORT",
                    employeeId: currentEmployee,
                    requestModel: {
                        ...params,
                        companyId: currentCompany,
                        employeeId: currentEmployee,
                        ...params.pagination,
                        ...search,
                        ...pagination,
                        isReport: "Y"
                    }
                });
                console.log("creRes", creRes);
                async function timeout(delay) {
                    return new Promise(res => setTimeout(res, delay));
                }
                async function loopCheck(creRes) {
                    if (creRes.status == '200') {
                        let resData = await services.ExportcheckTxnReportProcessing({
                            reportId: creRes?.data?.content?.id
                        })
                        console.log("resData", resData, resData?.data?.content?.processStatus);
                        if (resData?.data?.content?.processStatus == 'PENDING') {
                            await timeout(5000);
                            loopCheck(creRes)
                        } else if (resData?.data?.content?.processStatus == 'SUCCESS') {
                            downloadBytes(resData?.data?.content?.file, "workingTimeGroup.xlsx")
                        }
                    }
                }
                await loopCheck(creRes)
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
                setIsDownloading(false);
            }
        },
        [currentCompany, pagination, search, dispatch]
    );

    const TA_MAX_DAYS = 300;

    const exportTimeAttendanceReport = useCallback(async () => {
        const {
            startDate, endDate, employeeNo, employeeFullName,
            departmentId, positionId, branchId, employeeStatusId,
        } = search || {};
        if (!startDate || !endDate) return;
        if (dayjs(endDate).diff(dayjs(startDate), "day") + 1 > TA_MAX_DAYS) {
            message.warning(t("time_attendance_report.max_days", { defaultValue: `Date range must not exceed ${TA_MAX_DAYS} days` }));
            return;
        }
        try {
            setIsDownloadingTA(true);
            const res = await services.ExportTimeAttendanceReport({
                companyId: currentCompany,
                employeeId: currentEmployee,
                startDate,
                endDate,
                employeeNo: employeeNo?.trim() || null,
                employeeFullName: employeeFullName?.trim() || null,
                departmentId: departmentId ?? [],
                positionId: positionId ?? [],
                branchId: branchId ?? [],
                employeeStatusId: employeeStatusId ?? null,
                lang: i18n.language === "en" ? "en" : "th",
            });
            const filename = `time_attendance_${startDate.replaceAll("-", "")}_${endDate.replaceAll("-", "")}.xlsx`;
            const url = window.URL.createObjectURL(res.data);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            const body = error?.response?.data;
            const msg = body instanceof Blob ? await body.text() : error?.message;
            message.error(msg || "Download failed");
        } finally {
            setIsDownloadingTA(false);
        }
    }, [currentCompany, currentEmployee, search, i18n.language, t]);

    const downloadBytes = (bytes, filename, mimeType = "application/octet-stream") => {
        const byteCharacters = atob(bytes); // Decode Base64 to binary string
        const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: mimeType });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();

        URL.revokeObjectURL(url); // Clean up
    };


    const handleSearch = (values) => {
        setShowReport(true)
        setSearch({})
        console.log("handleSearch", values);
        try {
            setSearch({
                ...values,
                startDate: values?.workingTimeDate?.[0] ? values?.workingTimeDate?.[0]?.format('YYYY-MM-DD') : null,
                endDate: values?.workingTimeDate?.[1] ? values?.workingTimeDate?.[1]?.format('YYYY-MM-DD') : null
            })
            getReportTableWorkingTime({
                ...values,
                startDate: values?.workingTimeDate?.[0] ? values?.workingTimeDate?.[0]?.format('YYYY-MM-DD') : null,
                endDate: values?.workingTimeDate?.[1] ? values?.workingTimeDate?.[1]?.format('YYYY-MM-DD') : null,
                ...pagination
            })
            getReportTableWorkingTimeCustomer({
                ...values,
                startDate: values?.workingTimeDate?.[0] ? values?.workingTimeDate?.[0]?.format('YYYY-MM-DD') : null,
                endDate: values?.workingTimeDate?.[1] ? values?.workingTimeDate?.[1]?.format('YYYY-MM-DD') : null,
                ...pagination
            })
        } catch (error) {
            console.log("error", error);

        }

    };
    useEffect(() => {
        setLang(i18n.language);
    }, [i18n.language, setLang]);


    useEffect(() => {
        getDepartment();
        getEmployeeOptions();
        getPosition();
        getWorkInLocation();
        getEmployeeStstuaTypeOptions();
    }, [getDepartment, getPosition, getEmployeeStstuaTypeOptions, getWorkInLocation, getEmployeeOptions])
    return {
        showReport,
        handleSearch,
        employeeOptions: modifiedEmployeeOptions,
        reportTableWoringTime,
        departmentOptions: modifiedDepartmentOption,
        positionOptions: modifiedPositionOptions,
        workInLocationList: modifiedWorkInLocationList,
        getReportTableWorkingTime,
        getReportTableWorkingTimeCustomer,
        getWorkInLocation,
        employeeStatusTypeOptions,
        reportTableWoringTime2,
        pagination,
        pagination2,
        onChange,
        onChange2,
        getEmployeeStstuaTypeOptions,
        exportWorkingTimeGroupReport,
        exportWorkingTimeGroupReportAll,
        isModalOpen,
        setIsModalOpen,
        showModal,
        isDownloading,
        isDownloadingTA,
        exportTimeAttendanceReport
    }
}
export default useWorkingTimeGroup;